<template>
  <v-app>
    <v-main>
      <web-header></web-header>
      <floating-menu></floating-menu>
      <router-view :key="$route.fullPath" />
      <web-footer></web-footer>
    </v-main>
  </v-app>
</template>

<script>
import WebHeader from "@/views/header.vue";
import WebFooter from "@/views/footer.vue";
import FloatingMenu from "@/components/FloatingMenu.vue"

export default {
  name: 'App',
  components: {
    WebHeader,
    WebFooter,
    FloatingMenu
  }
}
</script>
